import { Dimensions } from "./Dimensions";
import { Direction } from "./Direction";

export function advanceIndexInDirection(
  index: number,
  direction: Direction,
  gridDimensions: Dimensions
): number {
  switch (direction) {
    case "up":
      return Math.max(0, index - gridDimensions.width);
    case "down":
      return Math.min(
        index + gridDimensions.width,
        gridDimensions.width * gridDimensions.height
      );
    case "left":
      return Math.max(0, index - 1);
    case "right":
      return Math.min(index + 1, gridDimensions.width * gridDimensions.height);
  }
}
